import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../api";
import { Users, Plus, Trash2, FileDown } from "lucide-react";
import { generateStaffReport } from "../../pdfReports";

function currentMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`;
}
const brl = (n) => (n || 0).toLocaleString("pt-BR", { style:"currency", currency:"BRL" });
const EMPTY = { name:"", role:"Manicure", phone:"", commission_pct:40, active:true };

export default function StaffTab() {
  const [staff, setStaff] = useState([]);
  const [overview, setOverview] = useState([]);
  const [month, setMonth] = useState(currentMonth());
  const [form, setForm] = useState(EMPTY);

  const load = () => {
    api.get("/admin/staff").then(r=>setStaff(r.data));
    api.get("/admin/staff-overview", { params:{ month } }).then(r=>setOverview(r.data));
  };
  useEffect(load, [month]);

  const create = async () => {
    if (!form.name) { toast.error("Nome obrigatório"); return; }
    await api.post("/admin/staff", { ...form, commission_pct: Number(form.commission_pct)||0 });
    toast.success("Profissional cadastrada");
    setForm(EMPTY); load();
  };
  const del = async (id) => {
    if (!window.confirm("Excluir profissional?")) return;
    await api.delete(`/admin/staff/${id}`); toast.success("Excluída"); load();
  };
  const updateCommission = async (s, pct) => {
    await api.patch(`/admin/staff/${s.staff_id}`, { ...s, commission_pct: Number(pct)||0 });
    toast.success("Comissão atualizada"); load();
  };

  return (
    <div className="space-y-6">
      <div className="card-arya p-6 flex flex-wrap items-end gap-4">
        <div>
          <label className="text-xs tracking-widest font-display text-[color:var(--sun-700)]">MÊS DE REFERÊNCIA</label>
          <input type="month" value={month} onChange={e=>setMonth(e.target.value)}
                 className="block mt-1 rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid="staff-month"/>
        </div>
        <button onClick={()=>generateStaffReport({ month, rows: overview })}
                className="btn-ghost inline-flex items-center gap-2" data-testid="btn-pdf-staff">
          <FileDown size={14}/> Baixar PDF de comissões
        </button>
        <p className="text-xs text-[color:var(--ink-500)] flex-1 min-w-[240px]">
          A soma de atendimentos e comissão considera apenas serviços com status <b>concluído</b> no mês. Vincule uma profissional a cada agendamento pela aba <b>Agendamentos</b>.
        </p>
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 card-arya overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-[var(--cream-100)] text-left text-xs tracking-widest font-display">
              <tr><th className="p-4">PROFISSIONAL</th><th className="p-4">TELEFONE</th><th className="p-4">ATEND.</th><th className="p-4">BRUTO</th><th className="p-4">COMISSÃO</th><th className="p-4">A PAGAR</th><th className="p-4"></th></tr>
            </thead>
            <tbody className="divide-y divide-[var(--line)]">
              {overview.map(o => (
                <tr key={o.staff.staff_id} data-testid={`staff-${o.staff.staff_id}`}>
                  <td className="p-4">
                    <div className="font-display font-semibold">{o.staff.name}</div>
                    <div className="text-xs text-[color:var(--ink-500)]">{o.staff.role}</div>
                  </td>
                  <td className="p-4 text-xs">{o.staff.phone || "—"}</td>
                  <td className="p-4"><span className="font-serif text-xl text-[color:var(--sun-700)]">{o.count}</span></td>
                  <td className="p-4">{brl(o.gross)}</td>
                  <td className="p-4">
                    <input type="number" step="0.5" defaultValue={o.staff.commission_pct}
                           onBlur={e => updateCommission(o.staff, e.target.value)}
                           className="w-20 rounded-xl border border-[var(--line)] bg-white px-2 py-1 text-sm"
                           data-testid={`cmm-${o.staff.staff_id}`}/> <span className="text-xs">%</span>
                  </td>
                  <td className="p-4 font-serif text-lg text-[color:var(--success)]">{brl(o.commission_amount)}</td>
                  <td className="p-4"><button onClick={()=>del(o.staff.staff_id)} className="p-1 text-[color:var(--danger)]" data-testid={`del-staff-${o.staff.staff_id}`}><Trash2 size={16}/></button></td>
                </tr>
              ))}
              {overview.length===0 && <tr><td colSpan="7" className="p-8 text-center text-[color:var(--ink-500)]">Nenhuma profissional ativa.</td></tr>}
            </tbody>
          </table>
        </div>

        <div className="card-arya p-6 h-fit">
          <h3 className="font-serif text-xl mb-3 flex items-center gap-2"><Users size={16}/> Nova profissional</h3>
          <div className="space-y-2">
            <input placeholder="Nome" value={form.name} onChange={e=>setForm({...form, name:e.target.value})}
                   className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid="staff-name"/>
            <input placeholder="Função (ex: Manicure, Designer)" value={form.role} onChange={e=>setForm({...form, role:e.target.value})}
                   className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm"/>
            <input placeholder="Telefone" value={form.phone} onChange={e=>setForm({...form, phone:e.target.value})}
                   className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm"/>
            <label className="text-xs text-[color:var(--ink-500)]">Comissão (%)</label>
            <input type="number" step="0.5" value={form.commission_pct} onChange={e=>setForm({...form, commission_pct:e.target.value})}
                   className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid="staff-pct"/>
            <button onClick={create} className="btn-gold w-full inline-flex items-center justify-center gap-2" data-testid="btn-save-staff"><Plus size={14}/> Cadastrar</button>
          </div>
        </div>
      </div>

      <StaffAssignPanel staff={staff} onChange={load}/>
    </div>
  );
}

function StaffAssignPanel({ staff, onChange }) {
  const [apts, setApts] = useState([]);
  useEffect(() => {
    api.get("/admin/appointments").then(r=>setApts(r.data.filter(a => a.status !== "cancelled")));
  }, []);

  const assign = async (aptId, staffId) => {
    const s = staff.find(x => x.staff_id === staffId);
    await api.patch(`/admin/appointments/${aptId}/staff`, { staff_id: staffId || null, staff_name: s?.name || null });
    toast.success("Profissional atribuída"); onChange();
  };

  return (
    <div className="card-arya p-6">
      <h3 className="font-serif text-xl mb-4">Atribuir profissional aos agendamentos</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[var(--cream-100)] text-left text-xs tracking-widest font-display">
            <tr><th className="p-3">DATA</th><th className="p-3">CLIENTE</th><th className="p-3">SERVIÇO</th><th className="p-3">STATUS</th><th className="p-3">PROFISSIONAL</th></tr>
          </thead>
          <tbody className="divide-y divide-[var(--line)]">
            {apts.slice(0, 25).map(a => (
              <tr key={a.appointment_id}>
                <td className="p-3">{new Date(a.start_at).toLocaleString("pt-BR", { dateStyle:"short", timeStyle:"short" })}</td>
                <td className="p-3">{a.user_name}</td>
                <td className="p-3">{a.service_title}</td>
                <td className="p-3"><span className="tag-sun">{a.status}</span></td>
                <td className="p-3">
                  <select defaultValue={a.staff_id || ""} onChange={e=>assign(a.appointment_id, e.target.value)}
                          className="rounded-xl border border-[var(--line)] bg-white px-2 py-1 text-sm"
                          data-testid={`assign-${a.appointment_id}`}>
                    <option value="">— Sem atribuição —</option>
                    {staff.map(s => <option key={s.staff_id} value={s.staff_id}>{s.name}</option>)}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
